import React, { useCallback } from 'react'
import { isNil } from 'ramda'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import momentTimezone from 'moment-timezone'
import { Typography } from '@material-ui/core'
import { changeTimezone } from 'libs/dateUtils'
import { timeFormat, dateFormat } from 'commons/date'
import { CalendarClockIcon } from 'app/components/icons'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'

import {
  POLL_OPEN,
  POLL_TPYE_MULTI,
  POLL_TPYE_SINGLE,
} from 'app/constants/messageDetail'

const PollDetailsOnDetail = ({ data }) => {
  const { type, status, endDate, endTimezone } = data //isAnonymous

  const { formatMessage } = useIntl()

  const displayEndDate = useCallback(
    (status, endDate, timeZone = momentTimezone.tz.guess()) => {
      const isOpen = status === POLL_OPEN
      const isEndDate = !isNil(endDate)

      const date = changeTimezone(endDate, timeZone)?.format(dateFormat) ?? ''
      const time = changeTimezone(endDate, timeZone)?.format(timeFormat) ?? ''
      const offsets = momentTimezone.tz(timeZone)?.format('Z') ?? ''

      const msgDate =
        formatMessage({ id: 'label.date.utc' }, { date, time, offsets }) ?? ''

      if (isOpen && isEndDate) {
        return (
          <Typography
            component="p"
            className="break-word text-grey-300 text-12 flex item-center"
          >
            <span className="mr-3">
              <CalendarClockIcon fill="#8D8D8D" />
            </span>
            {formatMessage(
              { id: 'label.ends.on' },
              {
                date: msgDate,
              },
            )}
          </Typography>
        )
      } else if (isOpen && !isEndDate) {
        return (
          <Typography
            component="p"
            className="break-word text-green-600 text-12 flex item-center"
          >
            <span className="mr-3">
              <CalendarClockIcon fill="#16A34A" />
            </span>
            {formatMessage({ id: 'label.open' })}
          </Typography>
        )
      } else if (!isOpen && isEndDate) {
        return (
          <Typography
            component="p"
            className="break-word text-red-500 text-12 flex item-center"
          >
            <span className="mr-3">
              <CalendarClockIcon fill="#EF4444" />
            </span>
            {formatMessage(
              { id: 'label.ends.on' },
              {
                date: msgDate,
              },
            )}
          </Typography>
        )
      } else return null
    },
    [formatMessage],
  )

  const displayType = useCallback(
    (type) => {
      if (type === POLL_TPYE_SINGLE) return null
      else if (type === POLL_TPYE_MULTI) {
        return (
          <Typography
            component="p"
            className="break-word text-grey-300 text-12 flex item-center"
          >
            <span className="mr-3">
              <CheckCircleOutlineIcon fontSize="small" />
            </span>
            {formatMessage({ id: 'poll.type.multi.vote' })}
          </Typography>
        )
      } else return null
    },
    [formatMessage],
  )

  // const displayAnonymous = useCallback(
  //   (isAnonymous) => {
  //     let message = null

  //     if (isAnonymous) message = formatMessage({ id: 'poll.anonymous.vote' })
  //     else message = null

  //     return message
  //   },
  //   [formatMessage],
  // )

  return (
    <div className="space-y-5">
      {displayEndDate(status, endDate, endTimezone)}
      {displayType(type)}
      {/* {displayAnonymous(isAnonymous)} */}
    </div>
  )
}

PollDetailsOnDetail.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    type: PropTypes.string,
    status: PropTypes.string,
    endDate: PropTypes.string,
    isAnonymous: PropTypes.bool,
    optionCount: PropTypes.number,
    endTimezone: PropTypes.string,
  }),
}

export default PollDetailsOnDetail
